// src/redux/settingsPages/helpcenter/helpcenterActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import HelpcenterAPI from './helpcenterAPI';

export const fetchHelpCategories = createAsyncThunk(
  'helpcenter/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      return await HelpcenterAPI.fetchCategories();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load help categories');
    }
  }
);

export const searchHelpArticles = createAsyncThunk(
  'helpcenter/searchArticles',
  async (query, { rejectWithValue }) => {
    try {
      return await HelpcenterAPI.searchArticles(query);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Search failed');
    }
  },
  {
    condition: (query) => Boolean(String(query || '').trim()),
  }
);

export const submitFeedback = createAsyncThunk(
  'helpcenter/submitFeedback',
  async (payload, { rejectWithValue }) => {
    try {
      return await HelpcenterAPI.submitFeedback(payload);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Could not submit feedback');
    }
  }
);
